import { ROLE_MAPPER } from '@Config/config'

import { type IRole } from '../types/authType'

import { onCheckListRolePresence } from './onCheckListRolePresence'

export const onSetMainRole = (roles: IRole[]): IRole => {
    const { SADMN, RADMN, DMSMR, UNKNOWN } = ROLE_MAPPER
    if (onCheckListRolePresence(roles, [SADMN])) {
        return SADMN
    } else if (onCheckListRolePresence(roles, [RADMN])) {
        return RADMN
    } else if (onCheckListRolePresence(roles, [DMSMR])) {
        return DMSMR
    } else {
        return UNKNOWN
    }
}
